import type { EmailDraftCardLabels } from '../../../../types/ai';

/**
 * Svarets text före mejlförhandsvisningen. Backenden skickar förhandsvisningen
 * som text för widgeten, som saknar kortet; här visar kortet den, så bara
 * hjärnans egna ord (t.ex. "ladda upp bilder innan du trycker Skicka") ska
 * stå i bubblan.
 */
export function textBeforeEmailDraft(
  content: string,
  labels: Pick<EmailDraftCardLabels, 'title' | 'subjectLabel'>,
): string {
  const cuts = [content.indexOf(labels.title), content.indexOf(`**${labels.subjectLabel}:**`)]
    .filter((index) => index >= 0);
  const before = cuts.length ? content.slice(0, Math.min(...cuts)) : content;
  return before
    .trim()
    .split('\n')
    .filter((line, index, lines) => !(index === lines.length - 1 && line.trim().endsWith(':')))
    .join('\n')
    .trim();
}
